"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#004864",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.2,13.1c-1.9-1.9-4.5-3-7.2-3c0,0,0,0,0,0c-2.7,0-5.3,1.1-7.2,3l-1.6-1.6C5.6,9.2,8.7,7.9,12,7.9 c0,0,0,0,0,0c3.3,0,6.4,1.3,8.8,3.6L19.2,13.1z"
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.6,8.8L0,7.2c6.6-6.6,17.4-6.6,24,0l-1.6,1.6C16.7,3,7.3,3.1,1.6,8.8z"
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,17.4c-2.2-2.2-5.8-2.2-8,0l-1.6-1.6c3.1-3.1,8.1-3.1,11.2,0L16,17.4z"
  })), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "19.9",
    r: "2.3"
  })));
};

exports["default"] = _default;